import Joi from 'joi';
import type { IRecognitionResult } from './recognitionResult';
import { recognitionResultSchema } from './recognitionResult';
import { actionCreator, objectSchemaOf } from '../helpers';

export const FINAL_RESULT = 'VOICE_TO_TEXT/FINAL_RESULT';

export interface IFinalResultPayload {
  conversationId: string;
  recordingId: string;
  recognitionResult: IRecognitionResult;
}

export interface IFinalResultAction {
  type: typeof FINAL_RESULT;
  payload: IFinalResultPayload;
}

export const finalResultPayloadSchema = objectSchemaOf<IFinalResultPayload>({
  conversationId: Joi.string().required(),
  recordingId: Joi.string().required(),
  recognitionResult: recognitionResultSchema.required(),
});

export const finalResultActionSchema = objectSchemaOf<IFinalResultAction>({
  type: Joi.string().required().valid(FINAL_RESULT),
  payload: finalResultPayloadSchema.required(),
});

export const finalResult = actionCreator({
  type: FINAL_RESULT,
  schema: finalResultActionSchema,
});
